import React, { useState } from "react";
import { useSelector } from "react-redux";
import classes from './SubmissionsList.module.css';
import SortArrowIcon from '../../../../../assests/assessments/sort-arrow.png';
import TasksIcon from '../../../../../assests/assessments/tasks.png';
import { onKeyDown } from "../../../../../service";
import * as SubmissionStatusEnum from "../../../../lms-shared/models/SubmissionStatus";

const SubmissionsList = ({ data, allAssessments, sort, changeAssessmentId }) => {

    const { texts, direction } = useSelector(state => state.translate);

    const [show, setShow] = useState(false);

    const getTitle = () => {
        switch (data.submissionStatusId) {
            case SubmissionStatusEnum.notStarted:
            case SubmissionStatusEnum.started: return texts.QuestionsFromStudents;
            case SubmissionStatusEnum.completed: return texts.CheckedAssignments;
            default: return texts.assessmentsToCheck;
        }
    }

    const tasksNum = allAssessments?.reduce((acc, o) => acc + parseInt(o.checked ? 0 : 1), 0)

    return (
        <div className={`${classes.SubmissionsList} ${show ? classes.ShowSubmissionsList : ''}`}>
            <div className={classes.SubmissionsListContainer}>
                <div className={classes.Title}>{getTitle()}</div>
                <div className={classes.Headers}>
                    <div className={classes.Header} onClick={() => sort('assessmentName')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => sort('assessmentName'))}>
                        <div>{texts.assessment}</div>
                        <img alt={texts.sort} title={texts.sort} src={SortArrowIcon} />
                    </div>
                    <div className={classes.Header} onClick={() => sort('firstName')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => sort('firstName'))}>
                        <div>{texts.studentName}</div>
                        <img alt={texts.sort} title={texts.sort} src={SortArrowIcon} />
                    </div>
                </div>
                <div className={`${classes[direction]} ${classes.AllAssessmentsOverflow}`}>
                    <div className={classes.AllAssessments}>
                        {allAssessments?.length ? allAssessments.map(assessment =>
                            <div key={assessment.id} className={`${classes.Row} ${data.id === assessment.id ? classes.RowActive : ''} ${assessment.checked ? classes.RowChecked : ''}`} onClick={() => changeAssessmentId(assessment)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeAssessmentId(assessment))}>
                                <div>{assessment.assessmentName}</div>
                                {assessment.submittedByUser.isGroup ?
                                    <div className={classes.Team}>
                                        {assessment.submittedByUser.name}
                                        <div className={classes.TeamMembersTooltipWrapper}>
                                            <div className={classes.TeamMembersTooltip}>
                                                {assessment.submittedByUser.users?.map(s => s.firstName + ' ' + s.lastName).join(', ')}
                                            </div>
                                        </div>
                                    </div> :
                                    <div>{assessment.submittedByUser.firstName} {assessment.submittedByUser.lastName}</div>
                                }
                            </div>) : <div>{texts.noDataToView}</div>}
                    </div>
                </div>
                {show ? <div className={classes.ArrowBtn} onClick={() => setShow(show => !show)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShow(show => !show))}>&#x203A;</div> : ''}
            </div>
            <div className={classes.SubmissionsListContainerResponsive} onClick={() => setShow(show => !show)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShow(show => !show))}>
                <img src={TasksIcon} />
                <div className={classes.TasksNum}>{tasksNum}</div>
            </div>
        </div>
    )
}

export default SubmissionsList;